/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 一个JSON对象，包含 `imageData` 字段，其值为你想要上传图片的完整Base64 Data URI。
 */
export type PostImageFrombase64Request = { imageData: string };

export const PostImageFrombase64Request$zodSchema: z.ZodType<
  PostImageFrombase64Request
> = z.object({
  imageData: z.string(),
}).describe(
  "一个JSON对象，包含 `imageData` 字段，其值为你想要上传图片的完整Base64 Data URI。",
);

export type PostImageFrombase64InternalServerErrorDetails = {};

export const PostImageFrombase64InternalServerErrorDetails$zodSchema: z.ZodType<
  PostImageFrombase64InternalServerErrorDetails
> = z.object({});

/**
 * 服务器内部错误。在解码或保存图片文件时发生了未知错误。请稍后重试。
 */
export type PostImageFrombase64InternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: PostImageFrombase64InternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const PostImageFrombase64InternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostImageFrombase64InternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() =>
      PostImageFrombase64InternalServerErrorDetails$zodSchema
    ).optional(),
    message: z.string().optional(),
  }).describe(
    "服务器内部错误。在解码或保存图片文件时发生了未知错误。请稍后重试。",
  );

export type PostImageFrombase64BadRequestDetails = {};

export const PostImageFrombase64BadRequestDetails$zodSchema: z.ZodType<
  PostImageFrombase64BadRequestDetails
> = z.object({});

/**
 * 请求失败。可能的原因有：请求体不是有效的JSON，缺少 `imageData` 字段，或者 `imageData` 的内容不是有效的Base64 Data URI。
 */
export type PostImageFrombase64BadRequestResponseBody = {
  code?: string | undefined;
  details?: PostImageFrombase64BadRequestDetails | undefined;
  message?: string | undefined;
};

export const PostImageFrombase64BadRequestResponseBody$zodSchema: z.ZodType<
  PostImageFrombase64BadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostImageFrombase64BadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe(
  "请求失败。可能的原因有：请求体不是有效的JSON，缺少 `imageData` 字段，或者 `imageData` 的内容不是有效的Base64 Data URI。",
);

/**
 * 上传成功！返回图片的访问地址。
 */
export type PostImageFrombase64ResponseBody = {
  image_url?: string | undefined;
  msg?: string | undefined;
};

export const PostImageFrombase64ResponseBody$zodSchema: z.ZodType<
  PostImageFrombase64ResponseBody
> = z.object({
  image_url: z.string().optional(),
  msg: z.string().optional(),
}).describe("上传成功！返回图片的访问地址。");

export type PostImageFrombase64Response =
  | PostImageFrombase64ResponseBody
  | PostImageFrombase64BadRequestResponseBody
  | PostImageFrombase64InternalServerErrorResponseBody;

export const PostImageFrombase64Response$zodSchema: z.ZodType<
  PostImageFrombase64Response
> = z.union([
  z.lazy(() => PostImageFrombase64ResponseBody$zodSchema),
  z.lazy(() => PostImageFrombase64BadRequestResponseBody$zodSchema),
  z.lazy(() => PostImageFrombase64InternalServerErrorResponseBody$zodSchema),
]);
